export default {
  isSecondTurn: {
    type: Boolean,
    default: false,
  },
  loadMoreProducts: {
    type: Boolean,
    default: false,
  },
  product: {
    type: Object,
    required: true,
  },
  callouts: {
    type: Array,
    default: () => [],
  },
  quickview: {
    type: Boolean,
    default: false,
  },
  quickviewBtn: {
    type: Boolean,
    default: false,
  },
  showOOSbadge: {
    type: Boolean,
    default: false,
  },
  gtmTrackId: {
    type: String,
    default: '',
  },
  isLoadingLazy: {
    type: Boolean,
    default: false,
  },
  isTrackClickEvent: {
    type: Boolean,
    default: false,
  },
  enableImageCarousel: {
    type: Boolean,
    default: false,
  },
  useLifestyleImage: {
    type: Boolean,
    default: false,
  },
  showDiscountBadge: {
    type: Boolean,
    default: false,
  },
  enableReviews: {
    type: Boolean,
    default: true,
  },
  selectedProducts: {
    type: Object,
    default: () => ({}),
  },
  layer: {
    type: String,
    default: '',
  },
  subcategory: {
    type: String,
    default: '',
  },
  enableViewProductDetailsCTA: {
    type: Boolean,
    default: false,
  },
  showProductCardInfo: {
    type: Boolean,
    default: true,
  },
  showCompare: {
    type: Boolean,
    default: false,
  },
  compareProducts: {
    type: Array,
    default: () => [],
  },
  selectedColorValue: {
    type: String,
    default: '',
  },
  showWishlistIcon: {
    type: Boolean,
    default: true,
  },
  newProductCard: {
    type: Boolean,
    default: false,
  },
  available: {
    type: Boolean,
    default: true,
  },
};
